import React, { useState } from 'react';
import { Avatar, Button, Flex } from 'antd';
import { faTrash, faUsers } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SlackEntity, SlackUser } from 'jf/api';
import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExButton } from 'jf/components/DevExButton';

import { RespondentDetailsDrawers } from './RespondentDetailsDrawer';

type SlackEntityDisplayProps = {
  slackUser: SlackUser;
  entityType?: SlackEntity.type;
  onDelete?: () => void;
  previewVersion?: boolean;
};

export const SlackEntityDisplay: React.FC<SlackEntityDisplayProps> = ({
  slackUser,
  entityType,
  onDelete,
  previewVersion = false,
}) => {
  const theme = useDevExTheme();
  const [detailsDrawerOpen, setDetailsDrawerOpen] = useState<boolean>(false);

  return (
    <>
      <RespondentDetailsDrawers
        open={detailsDrawerOpen}
        onClose={() => setDetailsDrawerOpen(false)}
        target={slackUser}
      />
      <Button
        style={{
          border: previewVersion ? 'none' : undefined,
          width: '100%',
          height: 'auto',
        }}
        type="default"
        onClick={() => !previewVersion && setDetailsDrawerOpen(true)}
        icon={
          onDelete && (
            <DevExButton
              icon={<FontAwesomeIcon icon={faTrash} />}
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            />
          )
        }
        iconPosition="end"
      >
        <Flex style={{ width: '100%', padding: 8 }} align="center" justify="space-between">
          <Flex gap={theme.variable.spacing.sm} align="center">
            <Avatar
              shape={'square'}
              style={{ backgroundColor: theme.color.background.active }}
              size="large"
              src={slackUser.profileImageUrl ?? <FontAwesomeIcon icon={faUsers} />}
            />
            <Flex vertical align="flex-start">
              {slackUser.realName}
              <div style={{ color: theme.color.text.secondary }}>
                {' '}
                {`${entityType === SlackEntity.type.CHANNEL ? '#' : '@'}${slackUser.userName}`}
              </div>
            </Flex>
          </Flex>
        </Flex>
      </Button>
    </>
  );
};
